import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../modal/LoadingModal";
import IdeaServices from "../../services/IdeaServices";
import PaymentServices from "../../services/PaymentServices";
import "./PTableIdea.css";
import { Label, GroupRow, GroupCol } from "../element/GlobalStyle";
import styled from "styled-components";

const FilterGroup = styled.div`
  display: flex;
  margin-buttom: 5px;
  @media screen and (max-width: 446px) {
    flex-direction: column;
  }
`;

const PTableLapPayReward = () => {
  const today = new Date();
  var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [ideas, setIdeas] = useState([]);
  const [ideasExist, setIdeasExist] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const dt = useRef(null);
  const [dateDari, setDateDari] = useState(firstDay);
  const [dateSampai, setDateSampai] = useState(lastDay);
  const [selectedIde, setSelectedIde] = useState(null);
  const [selectedFactory, setSelectedFactory] = useState({
    name: "All",
    code: 0,
  });
  const [display, setDisplay] = useState(false);
  const [periode, setPeriode] = useState(today);
  const [formError, setFormError] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [response, setResponse] = useState(null);
  const [errors, setErrors] = useState(null);

  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (dateDari && dateSampai) {
      setLoading(true);
      async function getAllIdeas() {
        setLoading(true);
        try {
          const res = await IdeaServices.getIdeaPaymentReward(
            dateDari.toDateString(),
            dateSampai.toDateString(),
            selectedFactory.code
          );
          setIdeas(res.data.data);
        } catch (err) {
          // console.log(err);
          setErrors(err);
        } finally {
          setLoading(false);
        }
      }
      getAllIdeas();
    }
  }, [dateDari, dateSampai, selectedFactory]);

  useEffect(() => {
    if (ideasExist) {
      if (!ideasExist.status) {
        if (ideasExist.data.length > 0) {
          toast.current.show({
            severity: "error",
            summary: "Validasi",
            detail: ideasExist.message,
            life: 3000,
          });
        } else {
          confirmUpdate();
        }
      } else {
        setIsSubmit(true);
      }
    }
  }, [ideasExist]);

  useEffect(() => {
    if (!formError && isSubmit) {
      if (isUpdate) {
        updatePayment();
      } else {
        createPayment();
      }
    }
  }, [formError, isSubmit, isUpdate]);

  useEffect(() => {
    if (response) {
      if (response.data.status) {
        toast.current.show({
          severity: "success",
          summary: "Berhasil",
          detail: response.data.message,
          life: 3000,
        });
        setDisplay(false);
        // sendEmail();
      } else {
        toast.current.show({
          severity: "error",
          summary: "Gagal",
          detail: response.data.message,
          life: 3000,
        });
      }
    }
  }, [response]);

  useEffect(() => {
    if (errors) {
      if (errors.response !== undefined && errors.response.status === 401) {
        navigate("/login");
      } else {
        navigate("/error");
      }
    }
  }, [errors, navigate]);

  const confirmUpdate = () => {
    confirmDialog({
      message:
        "Periode [" +
        Moment(periode).format("MM-YYYY") +
        "] sudah diproses payment, apakah yakin ingin lanjut?",
      header: "Konfirmasi update",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      acceptLabel: "Yakin",
      rejectLabel: "Tidak",
      accept: () => {
        setIsSubmit(true);
        setIsUpdate(true);
      },
    });
  };

  const rewardTemplate = (rowData) => {
    return <span>{rowData.rupiah.toLocaleString("en-US")}</span>;
  };

  const rewardFooter = () => {
    let total = 0;
    for (let item of ideas) {
      total += item.rupiah;
    }
    return <span>{total.toLocaleString("en-US")}</span>;
  };

  const jumlahFooter = () => {
    let total = 0;
    for (let item of ideas) {
      total += item.jumlah;
    }
    return <span>{total.toLocaleString("en-US")}</span>;
  };

  const filterClearTemplate = (options) => {
    return (
      <Button
        type="button"
        icon="pi pi-times"
        onClick={options.filterClearCallback}
        className="p-button-secondary"
      ></Button>
    );
  };

  const filterApplyTemplate = (options) => {
    return (
      <Button
        type="button"
        icon="pi pi-check"
        onClick={options.filterApplyCallback}
        className="p-button-success"
      ></Button>
    );
  };

  // const representativeFilterTemplate = (options) => {
  //   return (
  //     <MultiSelect
  //       value={options.value}
  //       options={representatives}
  //       itemTemplate={representativesItemTemplate}
  //       onChange={(e) => options.filterCallback(e.value)}
  //       optionLabel="name"
  //       placeholder="Any"
  //       className="p-column-filter"
  //     />
  //   );
  // };

  // const exportCSV = () => {
  //   dt.current.exportCSV();
  // };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(ideas);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "Payment Reward");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        // console.log(data);
        module.default.saveAs(
          data,
          fileName + "_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  // function formatPeriode(value) {
  //   return Moment(value).format("MM-YYYY");
  // }

  // const sendEmail = async () => {
  //   let file = null;
  //   let beforeimgfile = require("../../assets/logo.png");
  //   const reader = new FileReader();
  //   reader.onload = (x) => {
  //     file = x.target.result;
  //     console.log(file);
  //   };
  //   const formData = new FormData();
  //   const email = ["hamidi-mis@tsmu.co.id"];
  //   email.forEach((item) => {
  //     formData.append("toemail", item);
  //   });
  //   formData.append(
  //     "subject",
  //     "INFORMASI PROSES PEMBAYARAN PIP (PERMOHONAN IDEA PERBAIKAN) - " +
  //       formatPeriode(periode) +
  //       " "
  //   );
  //   formData.append(
  //     "body",
  //     '<table style="border-collapse: collapse; width: 100%; border: 1px solid black;" border="1"> <tbody> <tr style="text-align: justify;"> <th style="width: 25%; text-align: center; padding: 10px" rowspan="4"><img width="100px" src="http://pip.tsmu.co.id:81/Upload/Images/PIP/playstore220351724.ico" alt="img" /></th> <td style="width: 75%; background-color: darkblue; color: white;" colspan="7"> <p style="text-align: center; font-size: 20px; margin: 5px;"><strong><span style="text-decoration: underline;">INFORMASI PROSES PEMBAYARAN</span></strong></p> <p style="text-align: center; margin: 5px;"><strong>PIP (PERMOHONAN IDEA PERBAIKAN)</strong></p> </td> </tr> <tr style="height: 40px; text-align: justify;"> <td style="width: 10%; text-align: center;" rowspan="2">PERIODE</td> <td style="width: 20%; text-align: center;" colspan="2">FACTORY TANGERANG</td> <td style="width: 20%; text-align: center;" colspan="2">FACTORY CIKARANG</td> <td style="width: 20%; text-align: center;" colspan="2">TOTAL</td> </tr> <tr style="height: 40px; text-align: center;"> <td style="width: 10%;">JUMLAH PIP</td> <td style="width: 10%;">Rp.</td> <td style="width: 10%;">JUMLAH PIP</td> <td style="width: 10%;">Rp.</td> <td style="width: 10%;">JUMLAH PIP</td> <td style="width: 10%;">Rp.</td> </tr> <tr style="height: 80px; text-align: center;"> <td style="width: 10%;">Juli 2022</td> <td style="width: 10%;">400</td> <td style="width: 10%;">Rp.4.000.000</td> <td style="width: 10%;">600</td> <td style="width: 10%;">Rp. 6.000.000</td> <td style="width: 10%;">1000</td> <td style="width: 10%;">Rp. 10.000.000</td> </tr> <tr> <td style="width: 25%; font-size: 11px; padding: 5px; text-align: justify;"><em>E-mail ini dibuat otomatis, mohon tidak membalas. Jika butuh bantuan, silahkan hubungi <strong>Komite / Quality System Dept..</strong></em></td> <td style="width: 75%; text-align: center; font-size: 12px; background-color: lawngreen;" colspan="7"><strong><em>Mohon Personnel General Affairs Dept. untuk melakukan proses pembayaran melalui gaji bulanan</em></strong></td> </tr> </tbody> </table>'
  //   );
  //   formData.append("attachments", null);
  //   try {
  //     const res = await PaymentServices.sendEmail(formData);
  //     console.log(res);
  //   } catch (err) {
  //     // setErrorsApi(err);
  //   } finally {
  //   }
  // };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, ideas);
        doc.save("Payment Reward.pdf");
      });
    });
  };

  const cols = [
    { field: "nik", header: "NIK" },
    { field: "nama", header: "Nama" },
    { field: "kriteria", header: "Kriteria" },
    { field: "jumlah", header: "Jumlah" },
    { field: "rupiah", header: "Rupiah" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const factories = [
    { name: "All", code: 0 },
    { name: "TNG", code: 1 },
    { name: "CKR", code: 3 },
  ];

  const onFactoryChange = (e) => {
    setSelectedFactory(e.value);
  };

  const handleProses = (e) => {
    validasi();
  };

  const validasi = async () => {
    periode.setDate(1);
    const values = {
      periode: periode.toDateString(),
      dateFrom: dateDari.toDateString(),
      dateTo: dateSampai.toDateString(),
      site: selectedFactory.code,
    };
    try {
      const res = await PaymentServices.validasiPayIdea(values);
      setIdeasExist(res.data);
    } catch (err) {
      // console.log(err);
      setErrors(err);
    } finally {
      // setLoading(false);
    }
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          label="Batal"
          icon="pi pi-times"
          onClick={() => {
            setDisplay(false);
            setPeriode(today);
            setFormError(null);
          }}
          className="p-button-text"
        />
        <Button
          label="Proses"
          icon="pi pi-check"
          onClick={() => handleProses()}
          autoFocus
        />
      </div>
    );
  };

  const createPayment = async () => {
    periode.setDate(1);
    const values = {
      periode: periode.toDateString(),
      dateFrom: dateDari.toDateString(),
      dateTo: dateSampai.toDateString(),
      site: selectedFactory.code,
    };
    setLoadingModal(true);
    try {
      const res = await PaymentServices.createPayIdea(values);
      setResponse(res);
    } catch (err) {
      // console.log(err);
      setErrors(err);
    } finally {
      setIsSubmit(false);
      setLoadingModal(false);
    }
  };

  const updatePayment = async () => {
    periode.setDate(1);
    const values = {
      periode: periode.toDateString(),
      dateFrom: dateDari.toDateString(),
      dateTo: dateSampai.toDateString(),
      site: selectedFactory.code,
    };
    setLoadingModal(true);
    try {
      const res = await PaymentServices.updatePayIdea(values);
      setResponse(res);
    } catch (err) {
      // console.log(err);
      setErrors(err);
    } finally {
      setIsSubmit(false);
      setLoadingModal(false);
    }
  };

  const handleCekPeriode = () => {
    if (
      dateSampai >=
      new Date(today.getFullYear(), today.getMonth(), today.getDate())
    ) {
      toast.current.show({
        severity: "error",
        summary: "Validasi",
        detail: "Periode PIP maksimal H-1 !",
        life: 3000,
      });
    } else if (ideas && ideas.length === 0) {
      toast.current.show({
        severity: "error",
        summary: "Validasi",
        detail: "Tidak ada data PIP!",
        life: 3000,
      });
    } else {
      setDisplay(true);
    }
  };

  const kriteriaFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={["S", "A", "B", "C", "D"]}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        placeholder="Pilih kriteria"
        panelStyle={{ fontSize: "0.8rem" }}
        showClear
      />
    );
  };

  return (
    <div>
      {loadingModal && <LoadingModal></LoadingModal>}
      <Toast ref={toast} />
      <ConfirmDialog />
      <Dialog
        header="Periode Payment"
        visible={display}
        onHide={() => {
          setDisplay(false);
          setPeriode(today);
          // setFormError(null);
        }}
        breakpoints={{ "960px": "75vw" }}
        style={{ width: "20vw" }}
        footer={renderFooter()}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Label>Periode</Label>
          <Calendar
            id="monthpicker"
            value={periode}
            onChange={(e) => setPeriode(e.value)}
            view="month"
            dateFormat="mm-yy"
            inputStyle={{
              fontSize: "0.8rem",
            }}
            style={{
              margin: "0px 5px",
            }}
          />
        </div>
      </Dialog>
      <FilterGroup
        style={{
          display: "flex",
          // marginBottom: "5px",
        }}
      >
        <GroupCol
          style={{
            marginBottom: "5px",
          }}
        >
          <GroupRow>
            <Label>Dari tgl</Label>
            <Calendar
              id="dtdari"
              value={dateDari}
              onChange={(e) => setDateDari(e.value)}
              dateFormat="dd-mm-yy"
              maxDate={dateSampai}
              readOnlyInput
              inputStyle={{
                fontSize: "0.8rem",
              }}
              style={{
                minWidth: "90px",
                marginTop: "2px",
                marginRight: "10px",
              }}
            />
          </GroupRow>
          <GroupRow>
            <Label>s/d</Label>
            <Calendar
              id="dtsampai"
              value={dateSampai}
              onChange={(e) => setDateSampai(e.value)}
              dateFormat="dd-mm-yy"
              minDate={dateDari}
              readOnlyInput
              inputStyle={{
                fontSize: "0.8rem",
              }}
              style={{
                minWidth: "90px",
                marginTop: "2px",
                marginRight: "10px",
              }}
            />
          </GroupRow>
          <GroupRow>
            <Label>Factory</Label>
            <Dropdown
              style={{
                marginTop: "2px",
                marginRight: "10px",
              }}
              panelStyle={{ fontSize: "0.8rem" }}
              optionLabel="name"
              value={selectedFactory}
              options={factories}
              onChange={onFactoryChange}
              placeholder="Pilih factory"
            />
          </GroupRow>
        </GroupCol>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            marginBottom: "5px",
          }}
        >
          <Button
            label="Proses Payment"
            style={{
              padding: "5px 15px",
              marginTop: "auto",
              marginRight: "10px",
              fontSize: "0.8rem",
            }}
            type="button"
            onClick={() => handleCekPeriode()}
            tooltip="Proses Payment"
            tooltipOptions={{ position: "bottom" }}
          ></Button>
          <div style={{ display: "flex", alignItems: "flex-end" }}>
            <Button
              style={{
                padding: "5px 15px",
                fontSize: "0.8rem",
                marginRight: "10px",
              }}
              type="button"
              icon="pi pi-file-excel"
              onClick={exportExcel}
              className="p-button-success mr-2"
              tooltip="XLS"
              tooltipOptions={{ position: "bottom" }}
            />
            <Button
              style={{
                padding: "5px 15px",
                fontSize: "0.8rem",
              }}
              type="button"
              icon="pi pi-file-pdf"
              onClick={exportPdf}
              className="p-button-warning mr-2"
              tooltip="PDF"
              tooltipOptions={{ position: "bottom" }}
            />
          </div>
        </div>
      </FilterGroup>
      <DataTable
        value={ideas}
        scrollable
        loading={loading}
        scrollDirection="both"
        className="header-class"
        rowClassName="row-class-report"
        ref={dt}
        removableSort
        selectionMode="single"
        selection={selectedIde}
        onSelectionChange={(e) => setSelectedIde(e.value)}
        emptyMessage="Data tidak ditemukan"
        scrollHeight="calc(100vh - 190px)"
      >
        <Column
          header="No"
          headerStyle={{ width: "3em" }}
          style={{ width: "3em" }}
          body={(data, options) => options.rowIndex + 1}
        ></Column>
        <Column
          field="nik"
          header="NIK"
          style={{ flexGrow: 1, flexBasis: "100px" }}
          sortable
          filter
          filterPlaceholder="Cari NIK"
          filterMatchMode="contains"
          showFilterOperator={false}
          showFilterMatchModes={false}
          showAddButton={false}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
        ></Column>
        <Column
          field="nama"
          header="Nama"
          style={{ flexGrow: 1, flexBasis: "150px" }}
          sortable
          filter
          filterPlaceholder="Cari nama"
          filterMatchMode="contains"
          showFilterOperator={false}
          showFilterMatchModes={false}
          showAddButton={false}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
        ></Column>
        <Column
          field="dept"
          header="Dept"
          style={{ flexGrow: 1, flexBasis: "100px" }}
          sortable
          filter
          filterPlaceholder="Cari dept"
          filterMatchMode="contains"
          showFilterOperator={false}
          showFilterMatchModes={false}
          showAddButton={false}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
        ></Column>
        <Column
          field="kriteria"
          header="Kriteria"
          style={{ flexGrow: 1, flexBasis: "120px" }}
          sortable
          filter
          showFilterOperator={false}
          showFilterMatchModes={false}
          showAddButton={false}
          filterClear={filterClearTemplate}
          filterApply={filterApplyTemplate}
          filterElement={kriteriaFilterTemplate}
          footer={"Total:"}
          footerStyle={{ padding: "5px 7px" }}
        ></Column>
        <Column
          field="jumlah"
          header="Jumlah Ide"
          style={{ flexGrow: 1, flexBasis: "80px" }}
          sortable
          footer={jumlahFooter}
          footerStyle={{ padding: "5px 7px" }}
        ></Column>
        <Column
          field="rupiah"
          header="Rupiah"
          body={rewardTemplate}
          style={{ flexGrow: 1, flexBasis: "80px" }}
          align="right"
          footer={rewardFooter}
          footerStyle={{ padding: "5px 7px" }}
        ></Column>
      </DataTable>
    </div>
  );
};

export default PTableLapPayReward;
